import { Descriptions, Typography } from 'antd';

import { DESCRIPTION_LABEL_WIDTH, EMPTY_VALUE } from './constants';

interface IDetailGroupProps {
  title?: React.ReactNode;
  children: React.ReactNode;
}

interface ICopyableIdProps {
  value?: string;
}

export const DetailGroup = ({ title, children }: IDetailGroupProps): JSX.Element => (
  <Descriptions
    title={title}
    bordered
    size="small"
    column={1}
    className="integration-monitoring__details-group"
    labelStyle={{ width: DESCRIPTION_LABEL_WIDTH }}
  >
    {children}
  </Descriptions>
);

// Ids are pasted into Application Insights, so they can be copied.
export const CopyableId = ({ value }: ICopyableIdProps): JSX.Element =>
  value ? (
    <Typography.Text code copyable>
      {value}
    </Typography.Text>
  ) : (
    <>{EMPTY_VALUE}</>
  );
